import React from 'react'
import { View } from 'react-native'

import TableCategoryAccordion from './TableCategoryAccordion/index.native'
import TableHeader from './TableHeader/index.native'
import type { Props } from './types'

const Table = (props: Props) => {
  return (
    <View>
      <TableHeader headerItems={props.data.header} />
      <View>
        {props.data.categoryRows.map((categoryRow, categoryRowIndex, categoryRows) => (
          <TableCategoryAccordion
            key={categoryRow.key}
            categoryRow={categoryRow}
            isLast={categoryRowIndex === categoryRows.length - 1}
          />
        ))}
      </View>
    </View>
  )
}

export default Table
